import { CreateParams } from '..'
import { Element } from 'zrender'
import { createImage, createList, createText } from '../helpers'

/**
 * Create a block tile.
 */
export function block({
    width,
    tile,
    refresh
}: CreateParams<Tile & { type: 'block' }>) {
    const elements: Element[] = []
    const padding = width * (1 / 10)
    const textWidth = width * (3 / 5) - padding
    const imgWidth = width - textWidth - padding

    let y = 0

    if (tile.title) {
        const title = createText(tile.title, 'xl', textWidth)
        title.y = y
        y += title.getBoundingRect().height + 5
        elements.push(title)
    }

    if (tile.subtitle) {
        const subtitle = createText(tile.subtitle, 'lg', textWidth)
        subtitle.y = y
        y += subtitle.getBoundingRect().height + 5
        elements.push(subtitle)
    }

    if (tile.text) {
        const text = createText(tile.text, 'md', textWidth)
        text.y = y
        y += text.getBoundingRect().height + 10
        elements.push(text)
    }

    if (tile.list) {
        const group = createList(tile.list, tile.listIcon, textWidth)
        group.y = y
        y += group.getBoundingRect().height
        elements.push(group)
    }

    if (tile.image) {
        const img = createImage(tile.image, (img, image) => {
            const height = image.height
            const width = image.width

            const ratio = height / width
            const targetHeight = imgWidth * ratio
            img.x = textWidth + padding

            if (targetHeight > y) {
                img.setStyle({
                    width: y / ratio,
                    height
                })
                img.x += (imgWidth - y / ratio) / 2
            } else {
                img.setStyle({
                    width: imgWidth,
                    height
                })
                img.y = (y - height) / 2
            }

            refresh()
        })

        elements.push(img)
    }

    return elements
}
